export const cellEditingFor = (editing, columnId)=>{
    var _editing_getCellError;
    return editing == null ? undefined : {
        isEditing: editing.editingColumnId === columnId,
        errorText: (_editing_getCellError = editing.getCellError) === null || _editing_getCellError === void 0 ? void 0 : _editing_getCellError.call(editing, columnId),
        bi: {
            name: 'edit_cell'
        },
        onStart: ()=>editing.onStart(columnId),
        onCommit: (value)=>editing.onCommit(columnId, value),
        onCancel: editing.onCancel
    };
};
